export const generateRankMathTags = (data: string): JSX.Element => {
	data = data.replaceAll("blog782.amigoedu.com.br", "www.amigoedu.com.br/blogdoamigo");
	const rankMathData = data.split("\n");

	return (
		<>
			{rankMathData.map((tag) => {
				const tagSplit = tag.split('"');
				const tagType = tagSplit[0];
				const tagNamePropertyValue = tagSplit[1];
				let tagContentValue = tagSplit[3];

				switch (tagType) {
					case "<meta name=":
						return <meta name={tagNamePropertyValue} content={tagContentValue} key={tagNamePropertyValue} />;
						break;
					case "<meta property=":
						return <meta property={tagNamePropertyValue} content={tagContentValue} key={tagNamePropertyValue} />;
						break;
					case "<link rel=":
						/* Remove a barra no final que o rankmath coloca na url canonica; */
						if (tagNamePropertyValue === "canonical" && tagContentValue.lastIndexOf("/") === tagContentValue.length - 1) {
							tagContentValue = tagContentValue.substring(0, tagContentValue.length - 1);
							tagContentValue = tagContentValue.replace("www.", "");
						}
						return <link rel={tagNamePropertyValue} href={tagContentValue} key={tagNamePropertyValue} />;
						break;
					case "<script type=":
						return (
							<script
								type="application/ld+json"
								dangerouslySetInnerHTML={{ __html: JSON.stringify(JSON.parse(tag.substring(60, tag.length - 9))) }}
								key={tagNamePropertyValue}
							/>
						);
						break;
				}

				if (tag.indexOf("<title>") !== -1) {
					const title = tag.substring(7, tag.length - 8);
					return <title key={title}>{title}</title>;
				}

				return null;
			})}
		</>
	);
};
